/**
 * Triggering DOM scoped events
 * note: usages domEvent.trigger(document) are only used to support legacy code that are not bound to elements for backward compatibility.
 *
 * All general events not directly tied to a DOM element should use @confluence-classic/confluence-event_DO_NOT_USE
 */

// eslint-disable-next-line no-restricted-imports
import $ from "jquery";

export function domBind(scope, eventType, eventData, handler) {
  if (typeof handler === "function") {
    return $(scope).bind(eventType, eventData, handler);
  } else {
    return $(scope).bind(eventType, eventData);
  }
}

export function domUnbind(scope, eventType, handler) {
  return $(scope).unbind(eventType, handler);
}

export function domTrigger(scope, eventType, extraParameters) {
  return $(scope).trigger(eventType, extraParameters);
}
